import axios from "axios";
import React, { useEffect, useState } from "react";
import styled from "styled-components";

function ShowCourseName(props) {
  const [courseName, setCourseName] = useState("");

  useEffect(() => {
    if (!props.courseId) return; // guard: no courseId → do nothing

    axios.post("/returnCourseName", { courseId: props.courseId })
      .then((res) => {
        const name = res?.data ?? "";
        setCourseName(name);

        // only update array if props look valid
        if (typeof props.changeCourseNameArray === "function") {
          const prev = Array.isArray(props.courseNameArrayValue)
            ? props.courseNameArrayValue
            : [];
          const idx = Number.isInteger(props.index) ? props.index : null;

          const next = prev.slice();       // clone, don’t mutate props directly
          if (idx !== null) next[idx] = name;

          props.changeCourseNameArray(next);
        }
      })
      .catch((err) => {
        console.error("[ShowCourseName] fetch failed", err);
      });
  }, [props.courseId, props.index, props.courseNameArrayValue, props.changeCourseNameArray]);

  useEffect(() => {
    if (courseName) {
      // console.log("course Info:", courseName);
    }
  }, [courseName]);

  //   useEffect(() => {
  //     console.log("Course Name:", courseName);
  //   }, [courseName]);

  useEffect(() => {
    // let newArray = [...props.allData];
    // for (var i = 0; i < newArray.length; i++) {
    //
    if (
      props?.courseName &&
      props?.courseName.trim() != "" &&
      courseName != "" &&
      props.allData
    ) {
      let newArray = [...props.allData];
      // console.log("I'm here:", props.allData);
      // console.log("I'm here:", props.keyProp);

      if (
        courseName.toUpperCase().indexOf(props.courseName.toUpperCase()) > -1
      ) {
        newArray[props.keyProp].displayCourse = false;
        // console.log("True", newArray[props.keyProp]);
      } else {
        newArray[props.keyProp].displayCourse = true;
        // console.log("False", newArray[props.keyProp]);
      }
      props.changeData(newArray);
    } else if (props.courseName == "" && props.allData) {
      let newArray = [...props.allData];
      newArray[props.keyProp].displayCourse = false;
      props.changeData(newArray);
    }
    // }
    // setRecordProps(newArray);
  }, [props?.courseName]);

  useEffect(() => {
    if (props?.changeState && courseName != "") {
      props.changeState(courseName);
    }
  }, [props?.changeState, courseName]);

  return <Container>{courseName ? courseName : <div></div>}</Container>;
}

export default ShowCourseName;

const Container = styled.div`
  /* margin: 0px 5px 0px 5px; */
  font-weight: 600;
`;
